// extracted by mini-css-extract-plugin
export default {"carousel":"LocationSection_carousel__VupZI","location":"LocationSection_location__AH-qO"};